import { connect } from 'react-redux';
import Page from '../pages/Page';
import { clickOnBrowseEvents as clickOnBrowseEventsAction } from '../actions/events';
import { getOrganizerIds } from '../selectors';

const _mapStateToProps = (state) => ({
    isLoading: state.isLoading,
    isOwner: state.collection.canCurate,
    collectionName: state.collection.name,
    userId: state.userId,
    organizerIds: getOrganizerIds(state),
    gaSettings: state.gaSettings,
    gaCategory: 'editorial-collection',
    isAuthenticated: state.isAuthenticated,
});

const _mapDispatchToProps = {
    handleClickBrowseEvents: clickOnBrowseEventsAction,
};

export default connect(_mapStateToProps, _mapDispatchToProps)(Page);
